/**
 * auth0-js v9.19.0
 * Author: Auth0
 * Date: 2022-01-25
 * License: MIT
 */
!function (global, factory) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = factory() : "function" == typeof define && define.amd ? define(factory) : (global = global || self).CordovaAuth0Plugin = factory();
}(this, function () {
  "use strict";

  var version_raw = "9.19.0",
      toString = Object.prototype.toString;

  function attribute(o, attr, type, text) {
    if (type = "array" === type ? "object" : type, o && typeof o[attr] !== type) throw new Error(text);
  }

  function variable(o, type, text) {
    if (typeof o !== type) throw new Error(text);
  }

  function value(o, values, text) {
    if (-1 === values.indexOf(o)) throw new Error(text);
  }

  var assert = {
    check: function check(o, config, attributes) {
      if (config.optional && !o || variable(o, config.type, config.message), "object" === config.type && attributes) for (var keys = Object.keys(attributes), index = 0; index < keys.length; index++) {
        var a = keys[index];
        attributes[a].optional && !o[a] || attributes[a].condition && !attributes[a].condition(o) || (attribute(o, a, attributes[a].type, attributes[a].message), attributes[a].values && value(o[a], attributes[a].values, attributes[a].value_message));
      }
    },
    attribute: attribute,
    variable: variable,
    value: value,
    isArray: function isArray(array) {
      return this.supportsIsArray() ? Array.isArray(array) : "[object Array]" === toString.call(array);
    },
    supportsIsArray: function supportsIsArray() {
      return null != Array.isArray;
    }
  };

  function objectAssignPolyfill(target) {
    if (null == target) throw new TypeError("Cannot convert first argument to object");

    for (var to = Object(target), i = 1; i < arguments.length; i++) {
      var nextSource = arguments[i];
      if (null != nextSource) for (var keysArray = Object.keys(Object(nextSource)), nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
        var nextKey = keysArray[nextIndex],
            desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        void 0 !== desc && desc.enumerable && (to[nextKey] = nextSource[nextKey]);
      }
    }

    return to;
  }

  var objectAssign = {
    get: function get() {
      return Object.assign ? Object.assign : objectAssignPolyfill;
    },
    objectAssignPolyfill: objectAssignPolyfill
  };

  function pick(object, keys) {
    return keys.reduce(function (prev, key) {
      return object[key] && (prev[key] = object[key]), prev;
    }, {});
  }

  function objectValues(obj) {
    var values = [];

    for (var key in obj) {
      values.push(obj[key]);
    }

    return values;
  }

  function extend() {
    var params = objectValues(arguments);
    return params.unshift({}), objectAssign.get().apply(void 0, params);
  }

  function getLocationFromUrl(href) {
    var match = href.match(/^(https?:|file:|chrome-extension:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
      href: href,
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7]
    };
  }

  function trim(options, key) {
    var trimmed = extend(options);
    return options[key] && (trimmed[key] = options[key].trim()), trimmed;
  }

  var objectHelper = {
    toSnakeCase: function toSnakeCase(object, exceptions) {
      return "object" != typeof object || assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], Object.keys(object).reduce(function (p, key) {
        return p[-1 === exceptions.indexOf(key) ? function (str) {
          for (var code, newKey = "", index = 0, wasPrevNumber = !0, wasPrevUppercase = !0; index < str.length;) {
            code = str.charCodeAt(index), !wasPrevUppercase && code >= 65 && code <= 90 || !wasPrevNumber && code >= 48 && code <= 57 ? (newKey += "_", newKey += str[index].toLowerCase()) : newKey += str[index].toLowerCase(), wasPrevNumber = code >= 48 && code <= 57, wasPrevUppercase = code >= 65 && code <= 90, index++;
          }

          return newKey;
        }(key) : key] = toSnakeCase(object[key]), p;
      }, {}));
    },
    toCamelCase: function toCamelCase(object, exceptions, options) {
      return "object" != typeof object || assert.isArray(object) || null === object ? object : (exceptions = exceptions || [], options = options || {}, Object.keys(object).reduce(function (p, key) {
        var parts,
            newKey = -1 === exceptions.indexOf(key) ? (parts = key.split("_")).reduce(function (p, c) {
          return p + c.charAt(0).toUpperCase() + c.slice(1);
        }, parts.shift()) : key;
        return p[newKey] = toCamelCase(object[newKey] || object[key], [], options), options.keepOriginal && (p[key] = toCamelCase(object[key], [], options)), p;
      }, {}));
    },
    blacklist: function blacklist(object, blacklistedKeys) {
      return Object.keys(object).reduce(function (p, key) {
        return -1 === blacklistedKeys.indexOf(key) && (p[key] = object[key]), p;
      }, {});
    },
    merge: function merge(object, keys) {
      return {
        base: keys ? pick(object, keys) : object,
        with: function _with(object2, keys2) {
          return object2 = keys2 ? pick(object2, keys2) : object2, extend(this.base, object2);
        }
      };
    },
    pick: pick,
    getKeysNotIn: function getKeysNotIn(obj, allowedKeys) {
      var notAllowed = [];

      for (var key in obj) {
        -1 === allowedKeys.indexOf(key) && notAllowed.push(key);
      }

      return notAllowed;
    },
    extend: extend,
    getOriginFromUrl: function getOriginFromUrl(url) {
      if (url) {
        var parsed = getLocationFromUrl(url);
        if (!parsed) return null;
        var origin = parsed.protocol + "//" + parsed.hostname;
        return parsed.port && (origin += ":" + parsed.port), origin;
      }
    },
    getLocationFromUrl: getLocationFromUrl,
    trimUserDetails: function trimUserDetails(options) {
      return function (options, keys) {
        return keys.reduce(trim, options);
      }(options, ["username", "email", "phoneNumber"]);
    },
    updatePropertyOn: function updatePropertyOn(obj, path, value) {
      "string" == typeof path && (path = path.split("."));
      var next = path[0];
      obj.hasOwnProperty(next) && (1 === path.length ? obj[next] = value : updatePropertyOn(obj[next], path.slice(1), value));
    }
  };

  function getWindow() {
    return window;
  }

  var windowHandler = {
    redirect: function redirect(url) {
      getWindow().location = url;
    },
    getDocument: function getDocument() {
      return getWindow().document;
    },
    getWindow: getWindow,
    getOrigin: function getOrigin() {
      var location = getWindow().location,
          origin = location.origin;
      return origin || (origin = objectHelper.getOriginFromUrl(location.href)), origin;
    }
  },
      commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function createCommonjsModule(fn, module) {
    return fn(module = {
      exports: {}
    }, module.exports), module.exports;
  }

  var urlJoin = createCommonjsModule(function (module) {
    var context, definition;
    context = commonjsGlobal, definition = function definition() {
      function normalize(strArray) {
        var resultArray = [];
        if (0 === strArray.length) return "";
        if ("string" != typeof strArray[0]) throw new TypeError("Url must be a string. Received " + strArray[0]);

        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
          var first = strArray.shift();
          strArray[0] = first + strArray[0];
        }

        strArray[0].match(/^file:\/\/\//) ? strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///") : strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");

        for (var i = 0; i < strArray.length; i++) {
          var component = strArray[i];
          if ("string" != typeof component) throw new TypeError("Url must be a string. Received " + component);
          "" !== component && (i > 0 && (component = component.replace(/^[\/]+/, "")), component = i < strArray.length - 1 ? component.replace(/[\/]+$/, "") : component.replace(/[\/]+$/, "/"), resultArray.push(component));
        }

        var str = resultArray.join("/"),
            parts = (str = str.replace(/\/(\?|&|#[^!])/g, "$1")).split("?");
        return str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
      }

      return function () {
        return normalize("object" == typeof arguments[0] ? arguments[0] : [].slice.call(arguments));
      };
    }, module.exports ? module.exports = definition() : context.urljoin = definition();
  }),
      origSymbol = commonjsGlobal.Symbol,
      ERROR_MESSAGE = "Function.prototype.bind called on incompatible ",
      slice = Array.prototype.slice,
      toStr = Object.prototype.toString,
      functionBind = Function.prototype.bind || function (that) {
    var target = this;
    if ("function" != typeof target || "[object Function]" !== toStr.call(target)) throw new TypeError(ERROR_MESSAGE + target);

    for (var bound, args = slice.call(arguments, 1), binder = function binder() {
      if (this instanceof bound) {
        var result = target.apply(this, args.concat(slice.call(arguments)));
        return Object(result) === result ? result : this;
      }

      return target.apply(that, args.concat(slice.call(arguments)));
    }, boundLength = Math.max(0, target.length - args.length), boundArgs = [], i = 0; i < boundLength; i++) {
      boundArgs.push("$" + i);
    }

    if (bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder), target.prototype) {
      var Empty = function Empty() {};

      Empty.prototype = target.prototype, bound.prototype = new Empty(), Empty.prototype = null;
    }

    return bound;
  },
      src = functionBind.call(Function.call, Object.prototype.hasOwnProperty),
      $SyntaxError = SyntaxError,
      $Function = Function,
      $TypeError = TypeError,
      getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
  },
      $gOPD = Object.getOwnPropertyDescriptor;

  if ($gOPD) try {
    $gOPD({}, "");
  } catch (e) {
    $gOPD = null;
  }

  var n,
      throwTypeError = function throwTypeError() {
    throw new $TypeError();
  },
      ThrowTypeError = $gOPD ? function () {
    try {
      return throwTypeError;
    } catch (calleeThrows) {
      try {
        return $gOPD(arguments, "callee").get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  }() : throwTypeError,
      hasSymbols$1 = "function" == typeof origSymbol && "function" == typeof Symbol && "symbol" == typeof origSymbol("foo") && "symbol" == typeof Symbol("bar") && function () {
    if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
    if ("symbol" == typeof Symbol.iterator) return !0;
    var obj = {},
        sym = Symbol("test"),
        symObj = Object(sym);
    if ("string" == typeof sym) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(sym)) return !1;
    if ("[object Symbol]" !== Object.prototype.toString.call(symObj)) return !1;

    for (sym in obj[sym] = 42, obj) {
      return !1;
    }

    if ("function" == typeof Object.keys && 0 !== Object.keys(obj).length) return !1;
    if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(obj).length) return !1;
    var syms = Object.getOwnPropertySymbols(obj);
    if (1 !== syms.length || syms[0] !== sym) return !1;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return !1;

    if ("function" == typeof Object.getOwnPropertyDescriptor) {
      var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
      if (42 !== descriptor.value || !0 !== descriptor.enumerable) return !1;
    }

    return !0;
  }(),
      getProto = Object.getPrototypeOf || function (x) {
    return x.__proto__;
  },
      needsEval = {},
      TypedArray = "undefined" == typeof Uint8Array ? void 0 : getProto(Uint8Array),
      INTRINSICS = {
    "%AggregateError%": "undefined" == typeof AggregateError ? void 0 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? void 0 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols$1 ? getProto([][Symbol.iterator]()) : void 0,
    "%AsyncFromSyncIteratorPrototype%": void 0,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": "undefined" == typeof Atomics ? void 0 : Atomics,
    "%BigInt%": "undefined" == typeof BigInt ? void 0 : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": "undefined" == typeof DataView ? void 0 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": "undefined" == typeof Float32Array ? void 0 : Float32Array,
    "%Float64Array%": "undefined" == typeof Float64Array ? void 0 : Float64Array,
    "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": "undefined" == typeof Int8Array ? void 0 : Int8Array,
    "%Int16Array%": "undefined" == typeof Int16Array ? void 0 : Int16Array,
    "%Int32Array%": "undefined" == typeof Int32Array ? void 0 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols$1 ? getProto(getProto([][Symbol.iterator]())) : void 0,
    "%JSON%": "object" == typeof JSON ? JSON : void 0,
    "%Map%": "undefined" == typeof Map ? void 0 : Map,
    "%MapIteratorPrototype%": "undefined" != typeof Map && hasSymbols$1 ? getProto(new Map()[Symbol.iterator]()) : void 0,
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": "undefined" == typeof Promise ? void 0 : Promise,
    "%Proxy%": "undefined" == typeof Proxy ? void 0 : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": "undefined" == typeof Reflect ? void 0 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": "undefined" == typeof Set ? void 0 : Set,
    "%SetIteratorPrototype%": "undefined" != typeof Set && hasSymbols$1 ? getProto(new Set()[Symbol.iterator]()) : void 0,
    "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols$1 ? getProto(""[Symbol.iterator]()) : void 0,
    "%Symbol%": hasSymbols$1 ? Symbol : void 0,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": "undefined" == typeof Uint8Array ? void 0 : Uint8Array,
    "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
    "%Uint16Array%": "undefined" == typeof Uint16Array ? void 0 : Uint16Array,
    "%Uint32Array%": "undefined" == typeof Uint32Array ? void 0 : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": "undefined" == typeof WeakMap ? void 0 : WeakMap,
    "%WeakRef%": "undefined" == typeof WeakRef ? void 0 : WeakRef,
    "%WeakSet%": "undefined" == typeof WeakSet ? void 0 : WeakSet
  },
      LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  },
      $concat = functionBind.call(Function.call, Array.prototype.concat),
      $spliceApply = functionBind.call(Function.apply, Array.prototype.splice),
      $replace = functionBind.call(Function.call, String.prototype.replace),
      $strSlice = functionBind.call(Function.call, String.prototype.slice),
      rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
      reEscapeChar = /\\(\\)?/g,
      stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1),
        last = $strSlice(string, -1);
    if ("%" === first && "%" !== last) throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    if ("%" === last && "%" !== first) throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    return $replace(string, rePropName, function (match, number, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    }), result;
  },
      getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var alias,
        intrinsicName = name;

    if (src(LEGACY_ALIASES, intrinsicName) && (intrinsicName = "%" + (alias = LEGACY_ALIASES[intrinsicName])[0] + "%"), src(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];
      if (value === needsEval && (value = function doEval(name) {
        var value;
        if ("%AsyncFunction%" === name) value = getEvalledConstructor("async function () {}");else if ("%GeneratorFunction%" === name) value = getEvalledConstructor("function* () {}");else if ("%AsyncGeneratorFunction%" === name) value = getEvalledConstructor("async function* () {}");else if ("%AsyncGenerator%" === name) {
          var fn = doEval("%AsyncGeneratorFunction%");
          fn && (value = fn.prototype);
        } else if ("%AsyncIteratorPrototype%" === name) {
          var gen = doEval("%AsyncGenerator%");
          gen && (value = getProto(gen.prototype));
        }
        return INTRINSICS[name] = value, value;
      }(intrinsicName)), void 0 === value && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
      return {
        alias: alias,
        name: intrinsicName,
        value: value
      };
    }

    throw new $SyntaxError("intrinsic " + name + " does not exist!");
  },
      getIntrinsic = function getIntrinsic(name, allowMissing) {
    if ("string" != typeof name || 0 === name.length) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && "boolean" != typeof allowMissing) throw new $TypeError('"allowMissing" argument must be a boolean');
    var parts = stringToPath(name),
        intrinsicBaseName = parts.length > 0 ? parts[0] : "",
        intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing),
        intrinsicRealName = intrinsic.name,
        value = intrinsic.value,
        skipFurtherCaching = !1,
        alias = intrinsic.alias;
    alias && (intrinsicBaseName = alias[0], $spliceApply(parts, $concat([0, 1], alias)));

    for (var i = 1, isOwn = !0; i < parts.length; i += 1) {
      var part = parts[i],
          first = $strSlice(part, 0, 1),
          last = $strSlice(part, -1);
      if (('"' === first || "'" === first || "`" === first || '"' === last || "'" === last || "`" === last) && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
      if ("constructor" !== part && isOwn || (skipFurtherCaching = !0), src(INTRINSICS, intrinsicRealName = "%" + (intrinsicBaseName += "." + part) + "%")) value = INTRINSICS[intrinsicRealName];else if (null != value) {
        if (!(part in value)) {
          if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
          return;
        }

        if ($gOPD && i + 1 >= parts.length) {
          var desc = $gOPD(value, part);
          value = (isOwn = !!desc) && "get" in desc && !("originalValue" in desc.get) ? desc.get : value[part];
        } else isOwn = src(value, part), value = value[part];

        isOwn && !skipFurtherCaching && (INTRINSICS[intrinsicRealName] = value);
      }
    }

    return value;
  },
      callBind = createCommonjsModule(function (module) {
    var $apply = getIntrinsic("%Function.prototype.apply%"),
        $call = getIntrinsic("%Function.prototype.call%"),
        $reflectApply = getIntrinsic("%Reflect.apply%", !0) || functionBind.call($call, $apply),
        $gOPD = getIntrinsic("%Object.getOwnPropertyDescriptor%", !0),
        $defineProperty = getIntrinsic("%Object.defineProperty%", !0),
        $max = getIntrinsic("%Math.max%");
    if ($defineProperty) try {
      $defineProperty({}, "a", {
        value: 1
      });
    } catch (e) {
      $defineProperty = null;
    }

    module.exports = function (originalFunction) {
      var func = $reflectApply(functionBind, $call, arguments);

      if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        desc.configurable && $defineProperty(func, "length", {
          value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
        });
      }

      return func;
    };

    var applyBind = function applyBind() {
      return $reflectApply(functionBind, $apply, arguments);
    };

    $defineProperty ? $defineProperty(module.exports, "apply", {
      value: applyBind
    }) : module.exports.apply = applyBind;
  }),
      $indexOf = (callBind.apply, callBind(getIntrinsic("String.prototype.indexOf"))),
      callBound = function callBound(name, allowMissing) {
    var intrinsic = getIntrinsic(name, !!allowMissing);
    return "function" == typeof intrinsic && $indexOf(name, ".prototype.") > -1 ? callBind(intrinsic) : intrinsic;
  },
      require$$0 = (n = Object.freeze({
    __proto__: null,
    default: {}
  })) && n.default || n,
      hasMap = "function" == typeof Map && Map.prototype,
      mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
      mapSize = hasMap && mapSizeDescriptor && "function" == typeof mapSizeDescriptor.get ? mapSizeDescriptor.get : null,
      mapForEach = hasMap && Map.prototype.forEach,
      hasSet = "function" == typeof Set && Set.prototype,
      setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
      setSize = hasSet && setSizeDescriptor && "function" == typeof setSizeDescriptor.get ? setSizeDescriptor.get : null,
      setForEach = hasSet && Set.prototype.forEach,
      weakMapHas = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
      weakSetHas = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
      weakRefDeref = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
      booleanValueOf = Boolean.prototype.valueOf,
      objectToString = Object.prototype.toString,
      functionToString = Function.prototype.toString,
      match = String.prototype.match,
      bigIntValueOf = "function" == typeof BigInt ? BigInt.prototype.valueOf : null,
      gOPS = Object.getOwnPropertySymbols,
      symToString = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null,
      hasShammedSymbols = "function" == typeof Symbol && "object" == typeof Symbol.iterator,
      isEnumerable = Object.prototype.propertyIsEnumerable,
      gPO = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (O) {
    return O.__proto__;
  } : null),
      inspectCustom = require$$0.custom,
      inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null,
      toStringTag = "function" == typeof Symbol && void 0 !== Symbol.toStringTag ? Symbol.toStringTag : null,
      objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, "quoteStyle") && "single" !== opts.quoteStyle && "double" !== opts.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, "maxStringLength") && ("number" == typeof opts.maxStringLength ? opts.maxStringLength < 0 && opts.maxStringLength !== 1 / 0 : null !== opts.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = !has(opts, "customInspect") || opts.customInspect;
    if ("boolean" != typeof customInspect && "symbol" !== customInspect) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (has(opts, "indent") && null !== opts.indent && "\t" !== opts.indent && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    if (void 0 === obj) return "undefined";
    if (null === obj) return "null";
    if ("boolean" == typeof obj) return obj ? "true" : "false";
    if ("string" == typeof obj) return function inspectString(str, opts) {
      if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength,
            trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
      }

      return wrapQuotes(str.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, lowbyte), "single", opts);
    }(obj, opts);
    if ("number" == typeof obj) return 0 === obj ? 1 / 0 / obj > 0 ? "0" : "-0" : String(obj);
    if ("bigint" == typeof obj) return String(obj) + "n";
    var maxDepth = void 0 === opts.depth ? 5 : opts.depth;
    if (void 0 === depth && (depth = 0), depth >= maxDepth && maxDepth > 0 && "object" == typeof obj) return isArray$1(obj) ? "[Array]" : "[Object]";

    var indent = function (opts, depth) {
      var baseIndent;
      if ("\t" === opts.indent) baseIndent = "\t";else {
        if (!("number" == typeof opts.indent && opts.indent > 0)) return null;
        baseIndent = Array(opts.indent + 1).join(" ");
      }
      return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
      };
    }(opts, depth);

    if (void 0 === seen) seen = [];else if (indexOf(seen, obj) >= 0) return "[Circular]";

    function inspect(value, from, noIndent) {
      if (from && (seen = seen.slice()).push(from), noIndent) {
        var newOpts = {
          depth: opts.depth
        };
        return has(opts, "quoteStyle") && (newOpts.quoteStyle = opts.quoteStyle), inspect_(value, newOpts, depth + 1, seen);
      }

      return inspect_(value, opts, depth + 1, seen);
    }

    if ("function" == typeof obj) {
      var name = function (f) {
        if (f.name) return f.name;
        var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
        if (m) return m[1];
        return null;
      }(obj),
          keys = arrObjKeys(obj, inspect);

      return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + keys.join(", ") + " }" : "");
    }

    if (isSymbol(obj)) {
      var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
      return "object" != typeof obj || hasShammedSymbols ? symString : markBoxed(symString);
    }

    if (function (x) {
      if (!x || "object" != typeof x) return !1;
      if ("undefined" != typeof HTMLElement && x instanceof HTMLElement) return !0;
      return "string" == typeof x.nodeName && "function" == typeof x.getAttribute;
    }(obj)) {
      for (var s = "<" + String(obj.nodeName).toLowerCase(), attrs = obj.attributes || [], i = 0; i < attrs.length; i++) {
        s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
      }

      return s += ">", obj.childNodes && obj.childNodes.length && (s += "..."), s += "</" + String(obj.nodeName).toLowerCase() + ">";
    }

    if (isArray$1(obj)) {
      if (0 === obj.length) return "[]";
      var xs = arrObjKeys(obj, inspect);
      return indent && !function (xs) {
        for (var i = 0; i < xs.length; i++) {
          if (indexOf(xs[i], "\n") >= 0) return !1;
        }

        return !0;
      }(xs) ? "[" + indentedJoin(xs, indent) + "]" : "[ " + xs.join(", ") + " ]";
    }

    if (function (obj) {
      return !("[object Error]" !== toStr$1(obj) || toStringTag && "object" == typeof obj && toStringTag in obj);
    }(obj)) {
      var parts = arrObjKeys(obj, inspect);
      return 0 === parts.length ? "[" + String(obj) + "]" : "{ [" + String(obj) + "] " + parts.join(", ") + " }";
    }

    if ("object" == typeof obj && customInspect) {
      if (inspectSymbol && "function" == typeof obj[inspectSymbol]) return obj[inspectSymbol]();
      if ("symbol" !== customInspect && "function" == typeof obj.inspect) return obj.inspect();
    }

    if (function (x) {
      if (!mapSize || !x || "object" != typeof x) return !1;

      try {
        mapSize.call(x);

        try {
          setSize.call(x);
        } catch (s) {
          return !0;
        }

        return x instanceof Map;
      } catch (e) {}

      return !1;
    }(obj)) {
      var mapParts = [];
      return mapForEach.call(obj, function (value, key) {
        mapParts.push(inspect(key, obj, !0) + " => " + inspect(value, obj));
      }), collectionOf("Map", mapSize.call(obj), mapParts, indent);
    }

    if (function (x) {
      if (!setSize || !x || "object" != typeof x) return !1;

      try {
        setSize.call(x);

        try {
          mapSize.call(x);
        } catch (m) {
          return !0;
        }

        return x instanceof Set;
      } catch (e) {}

      return !1;
    }(obj)) {
      var setParts = [];
      return setForEach.call(obj, function (value) {
        setParts.push(inspect(value, obj));
      }), collectionOf("Set", setSize.call(obj), setParts, indent);
    }

    if (function (x) {
      if (!weakMapHas || !x || "object" != typeof x) return !1;

      try {
        weakMapHas.call(x, weakMapHas);

        try {
          weakSetHas.call(x, weakSetHas);
        } catch (s) {
          return !0;
        }

        return x instanceof WeakMap;
      } catch (e) {}

      return !1;
    }(obj)) return weakCollectionOf("WeakMap");
    if (function (x) {
      if (!weakSetHas || !x || "object" != typeof x) return !1;

      try {
        weakSetHas.call(x, weakSetHas);

        try {
          weakMapHas.call(x, weakMapHas);
        } catch (s) {
          return !0;
        }

        return x instanceof WeakSet;
      } catch (e) {}

      return !1;
    }(obj)) return weakCollectionOf("WeakSet");
    if (function (x) {
      if (!weakRefDeref || !x || "object" != typeof x) return !1;

      try {
        return weakRefDeref.call(x), !0;
      } catch (e) {}

      return !1;
    }(obj)) return weakCollectionOf("WeakRef");
    if (function (obj) {
      return !("[object Number]" !== toStr$1(obj) || toStringTag && "object" == typeof obj && toStringTag in obj);
    }(obj)) return markBoxed(inspect(Number(obj)));
    if (function (obj) {
      if (!obj || "object" != typeof obj || !bigIntValueOf) return !1;

      try {
        return bigIntValueOf.call(obj), !0;
      } catch (e) {}

      return !1;
    }(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (function (obj) {
      return !("[object Boolean]" !== toStr$1(obj) || toStringTag && "object" == typeof obj && toStringTag in obj);
    }(obj)) return markBoxed(booleanValueOf.call(obj));
    if (function (obj) {
      return !("[object String]" !== toStr$1(obj) || toStringTag && "object" == typeof obj && toStringTag in obj);
    }(obj)) return markBoxed(inspect(String(obj)));

    if (!function (obj) {
      return !("[object Date]" !== toStr$1(obj) || toStringTag && "object" == typeof obj && toStringTag in obj);
    }(obj) && !function (obj) {
      return !("[object RegExp]" !== toStr$1(obj) || toStringTag && "object" == typeof obj && toStringTag in obj);
    }(obj)) {
      var ys = arrObjKeys(obj, inspect),
          isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object,
          protoTag = obj instanceof Object ? "" : "null prototype",
          stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr$1(obj).slice(8, -1) : protoTag ? "Object" : "",
          tag = (isPlainObject || "function" != typeof obj.constructor ? "" : obj.constructor.name ? obj.constructor.name + " " : "") + (stringTag || protoTag ? "[" + [].concat(stringTag || [], protoTag || []).join(": ") + "] " : "");
      return 0 === ys.length ? tag + "{}" : indent ? tag + "{" + indentedJoin(ys, indent) + "}" : tag + "{ " + ys.join(", ") + " }";
    }

    return String(obj);
  };

  function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = "double" === (opts.quoteStyle || defaultStyle) ? '"' : "'";
    return quoteChar + s + quoteChar;
  }

  function quote(s) {
    return String(s).replace(/"/g, "&quot;");
  }

  function isArray$1(obj) {
    return !("[object Array]" !== toStr$1(obj) || toStringTag && "object" == typeof obj && toStringTag in obj);
  }

  function isSymbol(obj) {
    if (hasShammedSymbols) return obj && "object" == typeof obj && obj instanceof Symbol;
    if ("symbol" == typeof obj) return !0;
    if (!obj || "object" != typeof obj || !symToString) return !1;

    try {
      return symToString.call(obj), !0;
    } catch (e) {}

    return !1;
  }

  var hasOwn = Object.prototype.hasOwnProperty || function (key) {
    return key in this;
  };

  function has(obj, key) {
    return hasOwn.call(obj, key);
  }

  function toStr$1(obj) {
    return objectToString.call(obj);
  }

  function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);

    for (var i = 0, l = xs.length; i < l; i++) {
      if (xs[i] === x) return i;
    }

    return -1;
  }

  function lowbyte(c) {
    var n = c.charCodeAt(0),
        x = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[n];
    return x ? "\\" + x : "\\x" + (n < 16 ? "0" : "") + n.toString(16).toUpperCase();
  }

  function markBoxed(str) {
    return "Object(" + str + ")";
  }

  function weakCollectionOf(type) {
    return type + " { ? }";
  }

  function collectionOf(type, size, entries, indent) {
    return type + " (" + size + ") {" + (indent ? indentedJoin(entries, indent) : entries.join(", ")) + "}";
  }

  function indentedJoin(xs, indent) {
    if (0 === xs.length) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + xs.join("," + lineJoiner) + "\n" + indent.prev;
  }

  function arrObjKeys(obj, inspect) {
    var isArr = isArray$1(obj),
        xs = [];

    if (isArr) {
      xs.length = obj.length;

      for (var i = 0; i < obj.length; i++) {
        xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
      }
    }

    var symMap,
        syms = "function" == typeof gOPS ? gOPS(obj) : [];

    if (hasShammedSymbols) {
      symMap = {};

      for (var k = 0; k < syms.length; k++) {
        symMap["$" + syms[k]] = syms[k];
      }
    }

    for (var key in obj) {
      has(obj, key) && (isArr && String(Number(key)) === key && key < obj.length || hasShammedSymbols && symMap["$" + key] instanceof Symbol || (/[^\w$]/.test(key) ? xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj)) : xs.push(key + ": " + inspect(obj[key], obj))));
    }

    if ("function" == typeof gOPS) for (var j = 0; j < syms.length; j++) {
      isEnumerable.call(obj, syms[j]) && xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
  }

  var $TypeError$1 = getIntrinsic("%TypeError%"),
      $WeakMap = getIntrinsic("%WeakMap%", !0),
      $Map = getIntrinsic("%Map%", !0),
      $weakMapGet = callBound("WeakMap.prototype.get", !0),
      $weakMapSet = callBound("WeakMap.prototype.set", !0),
      $weakMapHas = callBound("WeakMap.prototype.has", !0),
      $mapGet = callBound("Map.prototype.get", !0),
      $mapSet = callBound("Map.prototype.set", !0),
      $mapHas = callBound("Map.prototype.has", !0),
      listGetNode = function listGetNode(list, key) {
    for (var curr, prev = list; null !== (curr = prev.next); prev = curr) {
      if (curr.key === key) return prev.next = curr.next, curr.next = list.next, list.next = curr, curr;
    }
  },
      sideChannel = function sideChannel() {
    var $wm,
        $m,
        $o,
        channel = {
      assert: function assert(key) {
        if (!channel.has(key)) throw new $TypeError$1("Side channel does not contain " + objectInspect(key));
      },
      get: function get(key) {
        if ($WeakMap && key && ("object" == typeof key || "function" == typeof key)) {
          if ($wm) return $weakMapGet($wm, key);
        } else if ($Map) {
          if ($m) return $mapGet($m, key);
        } else if ($o) return function (objects, key) {
          var node = listGetNode(objects, key);
          return node && node.value;
        }($o, key);
      },
      has: function has(key) {
        if ($WeakMap && key && ("object" == typeof key || "function" == typeof key)) {
          if ($wm) return $weakMapHas($wm, key);
        } else if ($Map) {
          if ($m) return $mapHas($m, key);
        } else if ($o) return function (objects, key) {
          return !!listGetNode(objects, key);
        }($o, key);

        return !1;
      },
      set: function set(key, value) {
        $WeakMap && key && ("object" == typeof key || "function" == typeof key) ? ($wm || ($wm = new $WeakMap()), $weakMapSet($wm, key, value)) : $Map ? ($m || ($m = new $Map()), $mapSet($m, key, value)) : ($o || ($o = {
          key: {},
          next: null
        }), function (objects, key, value) {
          var node = listGetNode(objects, key);
          node ? node.value = value : objects.next = {
            key: key,
            next: objects.next,
            value: value
          };
        }($o, key, value));
      }
    };
    return channel;
  },
      replace = String.prototype.replace,
      percentTwenties = /%20/g,
      Format_RFC3986 = "RFC3986",
      formats = {
    default: Format_RFC3986,
    formatters: {
      RFC1738: function RFC1738(value) {
        return replace.call(value, percentTwenties, "+");
      },
      RFC3986: function RFC3986(value) {
        return String(value);
      }
    },
    RFC1738: "RFC1738",
    RFC3986: Format_RFC3986
  },
      has$1 = Object.prototype.hasOwnProperty,
      isArray$2 = Array.isArray,
      hexTable = function () {
    for (var array = [], i = 0; i < 256; ++i) {
      array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    }

    return array;
  }(),
      arrayToObject = function arrayToObject(source, options) {
    for (var obj = options && options.plainObjects ? Object.create(null) : {}, i = 0; i < source.length; ++i) {
      void 0 !== source[i] && (obj[i] = source[i]);
    }

    return obj;
  },
      utils = {
    arrayToObject: arrayToObject,
    assign: function assign(target, source) {
      return Object.keys(source).reduce(function (acc, key) {
        return acc[key] = source[key], acc;
      }, target);
    },
    combine: function combine(a, b) {
      return [].concat(a, b);
    },
    compact: function compact(value) {
      for (var queue = [{
        obj: {
          o: value
        },
        prop: "o"
      }], refs = [], i = 0; i < queue.length; ++i) {
        for (var item = queue[i], obj = item.obj[item.prop], keys = Object.keys(obj), j = 0; j < keys.length; ++j) {
          var key = keys[j],
              val = obj[key];
          "object" == typeof val && null !== val && -1 === refs.indexOf(val) && (queue.push({
            obj: obj,
            prop: key
          }), refs.push(val));
        }
      }

      return function (queue) {
        for (; queue.length > 1;) {
          var item = queue.pop(),
              obj = item.obj[item.prop];

          if (isArray$2(obj)) {
            for (var compacted = [], j = 0; j < obj.length; ++j) {
              void 0 !== obj[j] && compacted.push(obj[j]);
            }

            item.obj[item.prop] = compacted;
          }
        }
      }(queue), value;
    },
    decode: function decode(str, decoder, charset) {
      var strWithoutPlus = str.replace(/\+/g, " ");
      if ("iso-8859-1" === charset) return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);

      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    },
    encode: function encode(str, defaultEncoder, charset, kind, format) {
      if (0 === str.length) return str;
      var string = str;
      if ("symbol" == typeof str ? string = Symbol.prototype.toString.call(str) : "string" != typeof str && (string = String(str)), "iso-8859-1" === charset) return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
      });

      for (var out = "", i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);
        45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats.RFC1738 && (40 === c || 41 === c) ? out += string.charAt(i) : c < 128 ? out += hexTable[c] : c < 2048 ? out += hexTable[192 | c >> 6] + hexTable[128 | 63 & c] : c < 55296 || c >= 57344 ? out += hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c] : (i += 1, c = 65536 + ((1023 & c) << 10 | 1023 & string.charCodeAt(i)), out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | 63 & c]);
      }

      return out;
    },
    isBuffer: function isBuffer(obj) {
      return !(!obj || "object" != typeof obj) && !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    },
    isRegExp: function isRegExp(obj) {
      return "[object RegExp]" === Object.prototype.toString.call(obj);
    },
    maybeMap: function maybeMap(val, fn) {
      if (isArray$2(val)) {
        for (var mapped = [], i = 0; i < val.length; i += 1) {
          mapped.push(fn(val[i]));
        }

        return mapped;
      }

      return fn(val);
    },
    merge: function merge(target, source, options) {
      if (!source) return target;

      if ("object" != typeof source) {
        if (isArray$2(target)) target.push(source);else {
          if (!target || "object" != typeof target) return [target, source];
          (options && (options.plainObjects || options.allowPrototypes) || !has$1.call(Object.prototype, source)) && (target[source] = !0);
        }
        return target;
      }

      if (!target || "object" != typeof target) return [target].concat(source);
      var mergeTarget = target;
      return isArray$2(target) && !isArray$2(source) && (mergeTarget = arrayToObject(target, options)), isArray$2(target) && isArray$2(source) ? (source.forEach(function (item, i) {
        if (has$1.call(target, i)) {
          var targetItem = target[i];
          targetItem && "object" == typeof targetItem && item && "object" == typeof item ? target[i] = merge(targetItem, item, options) : target.push(item);
        } else target[i] = item;
      }), target) : Object.keys(source).reduce(function (acc, key) {
        var value = source[key];
        return has$1.call(acc, key) ? acc[key] = merge(acc[key], value, options) : acc[key] = value, acc;
      }, mergeTarget);
    }
  },
      has$2 = Object.prototype.hasOwnProperty,
      arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
      return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
      return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
      return prefix;
    }
  },
      isArray$3 = Array.isArray,
      push = Array.prototype.push,
      pushToArray = function pushToArray(arr, valueOrArray) {
    push.apply(arr, isArray$3(valueOrArray) ? valueOrArray : [valueOrArray]);
  },
      toISO = Date.prototype.toISOString,
      defaultFormat = formats.default,
      defaults = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: utils.encode,
    encodeValuesOnly: !1,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    indices: !1,
    serializeDate: function serializeDate(date) {
      return toISO.call(date);
    },
    skipNulls: !1,
    strictNullHandling: !1
  },
      stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel$1) {
    var v,
        obj = object;
    if (sideChannel$1.has(object)) throw new RangeError("Cyclic object value");

    if ("function" == typeof filter ? obj = filter(prefix, obj) : obj instanceof Date ? obj = serializeDate(obj) : "comma" === generateArrayPrefix && isArray$3(obj) && (obj = utils.maybeMap(obj, function (value) {
      return value instanceof Date ? serializeDate(value) : value;
    })), null === obj) {
      if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
      obj = "";
    }

    if ("string" == typeof (v = obj) || "number" == typeof v || "boolean" == typeof v || "symbol" == typeof v || "bigint" == typeof v || utils.isBuffer(obj)) return encoder ? [formatter(encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format)) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))] : [formatter(prefix) + "=" + formatter(String(obj))];
    var objKeys,
        values = [];
    if (void 0 === obj) return values;
    if ("comma" === generateArrayPrefix && isArray$3(obj)) objKeys = [{
      value: obj.length > 0 ? obj.join(",") || null : void 0
    }];else if (isArray$3(filter)) objKeys = filter;else {
      var keys = Object.keys(obj);
      objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
      var key = objKeys[i],
          value = "object" == typeof key && void 0 !== key.value ? key.value : obj[key];

      if (!skipNulls || null !== value) {
        var keyPrefix = isArray$3(obj) ? "function" == typeof generateArrayPrefix ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel$1.set(object, !0);
        var valueSideChannel = sideChannel();
        pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
      }
    }

    return values;
  },
      lib_stringify = (Object.prototype.hasOwnProperty, Array.isArray, function (object, opts) {
    var objKeys,
        obj = object,
        options = function (opts) {
      if (!opts) return defaults;
      if (null !== opts.encoder && void 0 !== opts.encoder && "function" != typeof opts.encoder) throw new TypeError("Encoder has to be a function.");
      var charset = opts.charset || defaults.charset;
      if (void 0 !== opts.charset && "utf-8" !== opts.charset && "iso-8859-1" !== opts.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      var format = formats.default;

      if (void 0 !== opts.format) {
        if (!has$2.call(formats.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
      }

      var formatter = formats.formatters[format],
          filter = defaults.filter;
      return ("function" == typeof opts.filter || isArray$3(opts.filter)) && (filter = opts.filter), {
        addQueryPrefix: "boolean" == typeof opts.addQueryPrefix ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: void 0 === opts.allowDots ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: "boolean" == typeof opts.charsetSentinel ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: void 0 === opts.delimiter ? defaults.delimiter : opts.delimiter,
        encode: "boolean" == typeof opts.encode ? opts.encode : defaults.encode,
        encoder: "function" == typeof opts.encoder ? opts.encoder : defaults.encoder,
        encodeValuesOnly: "boolean" == typeof opts.encodeValuesOnly ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: "function" == typeof opts.serializeDate ? opts.serializeDate : defaults.serializeDate,
        skipNulls: "boolean" == typeof opts.skipNulls ? opts.skipNulls : defaults.skipNulls,
        sort: "function" == typeof opts.sort ? opts.sort : null,
        strictNullHandling: "boolean" == typeof opts.strictNullHandling ? opts.strictNullHandling : defaults.strictNullHandling
      };
    }(opts);

    "function" == typeof options.filter ? obj = (0, options.filter)("", obj) : isArray$3(options.filter) && (objKeys = options.filter);
    var arrayFormat,
        keys = [];
    if ("object" != typeof obj || null === obj) return "";
    arrayFormat = opts && opts.arrayFormat in arrayPrefixGenerators ? opts.arrayFormat : opts && "indices" in opts ? opts.indices ? "indices" : "repeat" : "indices";
    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    objKeys || (objKeys = Object.keys(obj)), options.sort && objKeys.sort(options.sort);

    for (var sideChannel$1 = sideChannel(), i = 0; i < objKeys.length; ++i) {
      var key = objKeys[i];
      options.skipNulls && null === obj[key] || pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel$1));
    }

    var joined = keys.join(options.delimiter),
        prefix = !0 === options.addQueryPrefix ? "?" : "";
    return options.charsetSentinel && ("iso-8859-1" === options.charset ? prefix += "utf8=%26%2310003%3B&" : prefix += "utf8=%E2%9C%93&"), joined.length > 0 ? prefix + joined : "";
  });

  function PopupHandler(webAuth) {
    this.webAuth = webAuth, this._current_popup = null, this.options = null;
  }

  function PluginHandler(webAuth) {
    this.webAuth = webAuth;
  }

  function CordovaPlugin() {
    this.webAuth = null, this.version = version_raw, this.extensibilityPoints = ["popup.authorize", "popup.getPopupHandler"];
  }

  return PopupHandler.prototype.preload = function (options) {
    var _this = this,
        _window = windowHandler.getWindow(),
        url = options.url || "about:blank",
        popupOptions = options.popupOptions || {};

    popupOptions.location = "yes", delete popupOptions.width, delete popupOptions.height;
    var windowFeatures = lib_stringify(popupOptions, {
      encode: !1,
      delimiter: ","
    });
    return this._current_popup && !this._current_popup.closed || (this._current_popup = _window.open(url, "_blank", windowFeatures), this._current_popup.kill = function (success) {
      _this._current_popup.success = success, this.close(), _this._current_popup = null;
    }), this._current_popup;
  }, PopupHandler.prototype.load = function (url, _, options, cb) {
    var _this = this;

    this.url = url, this.options = options, this._current_popup ? this._current_popup.location.href = url : (options.url = url, this.preload(options)), this.transientErrorHandler = function (event) {
      _this.errorHandler(event, cb);
    }, this.transientStartHandler = function (event) {
      _this.startHandler(event, cb);
    }, this.transientExitHandler = function () {
      _this.exitHandler(cb);
    }, this._current_popup.addEventListener("loaderror", this.transientErrorHandler), this._current_popup.addEventListener("loadstart", this.transientStartHandler), this._current_popup.addEventListener("exit", this.transientExitHandler);
  }, PopupHandler.prototype.errorHandler = function (event, cb) {
    this._current_popup && (this._current_popup.kill(!0), cb({
      error: "window_error",
      errorDescription: event.message
    }));
  }, PopupHandler.prototype.unhook = function () {
    this._current_popup.removeEventListener("loaderror", this.transientErrorHandler), this._current_popup.removeEventListener("loadstart", this.transientStartHandler), this._current_popup.removeEventListener("exit", this.transientExitHandler);
  }, PopupHandler.prototype.exitHandler = function (cb) {
    this._current_popup && (this.unhook(), this._current_popup.success || cb({
      error: "window_closed",
      errorDescription: "Browser window closed"
    }));
  }, PopupHandler.prototype.startHandler = function (event, cb) {
    var _this = this;

    if (this._current_popup) {
      var callbackUrl = urlJoin("https:", this.webAuth.baseOptions.domain, "/mobile");

      if (!event.url || 0 === event.url.indexOf(callbackUrl + "#")) {
        var parts = event.url.split("#");

        if (1 !== parts.length) {
          var opts = {
            hash: parts.pop()
          };
          this.options.nonce && (opts.nonce = this.options.nonce), this.webAuth.parseHash(opts, function (error, result) {
            (error || result) && (_this._current_popup.kill(!0), cb(error, result));
          });
        }
      }
    }
  }, PluginHandler.prototype.processParams = function (params) {
    return params.redirectUri = urlJoin("https://" + params.domain, "mobile"), delete params.owp, params;
  }, PluginHandler.prototype.getPopupHandler = function () {
    return new PopupHandler(this.webAuth);
  }, CordovaPlugin.prototype.setWebAuth = function (webAuth) {
    this.webAuth = webAuth;
  }, CordovaPlugin.prototype.supports = function (extensibilityPoint) {
    var _window = windowHandler.getWindow();

    return (!!_window.cordova || !!_window.electron) && this.extensibilityPoints.indexOf(extensibilityPoint) > -1;
  }, CordovaPlugin.prototype.init = function () {
    return new PluginHandler(this.webAuth);
  }, CordovaPlugin;
});